import { Client } from '../../../../../projects/kiene-core/src/lib/components/client/classes/client';
import { Gruppe } from '../../../../../projects/kiene-core/src/lib/components/gruppen/classes/gruppe';

export interface DashboardSammelstelleDialogData {
    /** Preselected Betrieb from stepper / current client. */
    client?: Client | null;
    /** Optional preselected Zielgruppe (locks Einstalldatum to today). */
    gruppe?: Gruppe | null;
}

/** Close result: boolean = saved any existing; object = hand off to Einstall. */
export type DashboardSammelstelleDialogResult =
    | boolean
    | {
          openEinstallen: true;
          prefillOhrmarken: string[];
          gruppeId?: number | null;
          kundeId?: number | null;
          kp_einstalldatum?: string | null;
      };

export function isSammelstelleEinstallenHandoff(
    result: DashboardSammelstelleDialogResult | null | undefined,
): result is Extract<DashboardSammelstelleDialogResult, { openEinstallen: true }> {
    return !!result && typeof result === 'object' && result.openEinstallen === true;
}

/** Wide dialog for one-screen Sammelstelle (tablet album parity). */
export const dashboardSammelstelleDialogLayout = {
    width: '1280px',
    maxWidth: '96vw',
    maxHeight: '92vh',
    panelClass: 'dashboard-sammelstelle-dialog-panel',
    autoFocus: false,
    restoreFocus: false,
};
